import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Paper,
  Stack
} from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';

/**
 * ForbiddenPage - 403 Forbidden Error Page
 * 
 * Phase 5: M5.T5.3 - Permission Route Guards
 * 
 * Features:
 * - Clean, user-friendly 403 error page
 * - Shows when user doesn't have required permission
 * - Action buttons: Go Back, Go to Dashboard
 * - Turkish text
 * 
 * Triggered by:
 * - PermissionRoute component (when user lacks permission)
 * - Manual navigation to /403
 */
const ForbiddenPage = () => {
  const history = useHistory();
  
  const handleGoBack = () => {
    history.goBack();
  };
  
  const handleGoHome = () => {
    history.push('/dashboard');
  };
  
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'grey.50',
        py: 4
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: 5,
            textAlign: 'center',
            borderRadius: 2
          }}
        >
          {/* Icon */}
          <Box
            sx={{
              display: 'inline-flex',
              p: 3,
              borderRadius: '50%',
              bgcolor: 'error.light',
              mb: 3
            }}
          >
            <BlockIcon sx={{ fontSize: 64, color: 'error.main' }} />
          </Box>
          
          {/* Error Code */}
          <Typography
            variant="h1"
            fontWeight="bold"
            color="text.primary"
            gutterBottom
            sx={{ fontSize: { xs: '4rem', sm: '5rem' } }}
          >
            403
          </Typography>
          
          {/* Error Title */}
          <Typography
            variant="h5"
            fontWeight="600"
            color="text.primary"
            gutterBottom
            sx={{ mb: 2 }}
          >
            🚫 Erişim Engellendi
          </Typography>
          
          {/* Error Description */}
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 4 }}
          >
            Bu sayfaya erişim yetkiniz bulunmamaktadır.
            <br />
            Eğer erişiminiz olması gerektiğini düşünüyorsanız, lütfen yöneticinizle iletişime geçin.
          </Typography>
          
          {/* Action Buttons */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            justifyContent="center"
          >
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={handleGoBack}
              size="large"
            >
              Geri Dön
            </Button>
            <Button
              variant="contained"
              startIcon={<HomeIcon />}
              onClick={handleGoHome}
              size="large"
            >
              Ana Sayfa
            </Button>
          </Stack>
          
          {/* Additional Help Text */}
          <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid', borderColor: 'divider' }}>
            <Typography variant="caption" color="text.disabled">
              Hata Kodu: 403 Forbidden | Yetki Hatası
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default ForbiddenPage;

